type Props = {
  sections: readonly string[];
  current: number;
  onSelect: (index: number) => void;
};

const SectionNav = ({ sections, current, onSelect }: Props) => (
  <nav
    aria-label="Sections"
    className="fixed left-11 top-1/2 z-30 -translate-y-1/2 flex flex-col gap-1"
  >
    {sections.map((label, i) => {
      const active = current === i;
      return (
        <button
          key={label}
          type="button"
          onClick={() => onSelect(i)}
          aria-current={active ? "true" : undefined}
          className={`flex items-center gap-3 py-1.5 text-[11px] font-medium uppercase
            tracking-rail transition-colors duration-200
            ${active ? "text-ink" : "text-neutral-600 hover:text-neutral-300"}`}
        >
          <span
            className={`block h-0.5 transition-all duration-300
              ${active ? "w-[34px] bg-accent shadow-rail" : "w-[14px] bg-neutral-700"}`}
          />
          <span className="tabular-nums">{String(i + 1).padStart(2, "0")}</span>
          <span>{label}</span>
        </button>
      );
    })}
  </nav>
);

export default SectionNav;
